const getStrapiUrl = () =>
    process.env.REACT_APP_PROD_URL

const getStrapiApiToken = () =>
    process.env.REACT_APP_PROD_STRAPI_API_TOKEN

export { getStrapiApiToken };
export default getStrapiUrl;
